var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import SectionTitle from '@/common/components/SectionTitle/index.vue';
import { Vue, Component } from 'vue-property-decorator';
import { getInviteLink, getCompanyMember } from 'src/common/api/common';
var targetUrl = require('config/env').targetUrl;
var InviteCollaboratorPopover = /** @class */ (function (_super) {
    __extends(InviteCollaboratorPopover, _super);
    function InviteCollaboratorPopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.COPY_STATUS_NOT_COPY = 0; // 尚未复制状态
        _this.COPY_STATUS_SUCCESS = 1; // 复制成功状态
        _this.COPY_STATUS_DANGER = 2; // 复制失败状态
        _this.visible = false;
        _this.invitationLink = ''; // 邀请链接
        _this.copyStatus = _this.COPY_STATUS_NOT_COPY; // 复制状态 0 未复制 1 复制成功 2复制失败
        _this.membersList = []; // 项目成员列表
        _this.createdAt = null; // 链接有效开始时间
        _this.expiresAt = null; // 链接有效结束时间
        return _this;
    }
    Object.defineProperty(InviteCollaboratorPopover.prototype, "user", {
        get: function () {
            return this.$store.getters['getUserInfo'];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InviteCollaboratorPopover.prototype, "isFree", {
        get: function () {
            return this.user.type === 'TYPE_EXPER';
        },
        enumerable: false,
        configurable: true
    });
    /* methods */
    InviteCollaboratorPopover.prototype.init = function () {
        this.invitationLink = '';
        this.copyStatus = this.COPY_STATUS_NOT_COPY;
        this.loadData();
    };
    InviteCollaboratorPopover.prototype.loadData = function () {
        var _this = this;
        this.visible = true;
        // 加载数据
        getInviteLink().then(function (response) {
            _this.visible = true;
            if (!response) {
                return false;
            }
            _this.invitationLink = targetUrl + "login?invite=" + response.inviteCode;
            _this.createdAt = response.createdAt;
            _this.expiresAt = response.expiresAt;
        }, function () {
            _this.visible = false;
        });
        // 获取员工列表
        getCompanyMember().then(function (response) {
            _this.membersList = response || [];
        });
    };
    InviteCollaboratorPopover.prototype.copyLink = function () {
        if (this.copyStatus !== this.COPY_STATUS_NOT_COPY) {
            return false;
        }
        if (this.isFree && this.membersList.length >= 5) { // 项目人满
            this.$message.warning('复制失败');
            this.copyStatus = this.COPY_STATUS_DANGER;
            return false;
        }
        this.copy((this.invitationLink || '') + "\n\u5206\u4EAB\u4EBA\uFF1A" + (this.user.name || '') + "\n\u6240\u5C5E\u516C\u53F8\uFF1A" + (this.user.companyName || '') + "\n\u94FE\u63A5\u6709\u6548\u671F\uFF1A" + (this.createdAt || '') + "-" + (this.expiresAt || ''));
        this.copyStatus = this.COPY_STATUS_SUCCESS;
    };
    InviteCollaboratorPopover.prototype.copy = function (text) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, navigator.clipboard.writeText(text)];
                    case 1:
                        _a.sent();
                        this.$message.success('复制成功～');
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.error('复制失败: ', err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    InviteCollaboratorPopover = __decorate([
        Component({
            components: {
                SectionTitle: SectionTitle,
            },
        })
    ], InviteCollaboratorPopover);
    return InviteCollaboratorPopover;
}(Vue));
export default InviteCollaboratorPopover;
